import { useMemo } from 'react';
// import { useJoinDiscordRecommendation } from '../modules/JoinDiscordRecommendation'
// import { useVisitHelpCenterRecommendation } from '../modules/VisitHelpCenterRecommendation'
import { useBookACallRecommendation } from '../modules/BookACallRecommendation';
import { useLaunchStrategyRecommendation } from '../modules/LaunchStrategyRecommendation';
export const useWebviewHelpRecommendations = () => {
    const { bookACallRecommendation } = useBookACallRecommendation();
    const { launchStrategyRecommendation } = useLaunchStrategyRecommendation();
    // TODO: enable these recommendations once they are ready to show on mobile view
    // const { visitHelpCenterRecommendation } = useVisitHelpCenterRecommendation()
    // const { joinDiscordRecommendation } = useJoinDiscordRecommendation()
    const helpRecommendations = useMemo(() => {
        return [bookACallRecommendation, launchStrategyRecommendation];
    }, [bookACallRecommendation, launchStrategyRecommendation]);
    const isLoadingRecommendations = helpRecommendations.some(({ isLoading }) => isLoading);
    const enabledRecommendations = (() => {
        return helpRecommendations.filter(({ enabled }) => enabled);
    })();
    return {
        helpRecommendations: !isLoadingRecommendations ? enabledRecommendations : [],
    };
};
